export default __webpack_public_path__ + "static/media/food_network.34015c4d.jpg";